
export default function BookingGuide() {
  const steps = [
    {
      icon: 'ri-checkbox-circle-line',
      title: '예약 확정',
      description: '선택하신 매장에서 예약을 확인하면 카카오톡으로 알림을 보내드려요'
    },
    {
      icon: 'ri-time-line',
      title: '방문 시간',
      description: '예약 시간 10분 전까지 매장에 도착해주세요'
    },
    {
      icon: 'ri-calendar-event-line',
      title: '예약 변경',
      description: '예약 변경은 방문 24시간 전까지 가능해요'
    },
    {
      icon: 'ri-close-circle-line',
      title: '노쇼 방지',
      description: '무단 취소 시 향후 예약이 제한될 수 있어요'
    }
  ];

  const notices = [
    '예약 시간은 시술 시작 시간이며, 상담 시간이 추가로 소요될 수 있어요',
    '매장 사정에 따라 예약이 취소될 수 있으며, 이 경우 즉시 안내드려요',
    '시술 전 알레르기나 피부 트러블이 있다면 미리 말씀해주세요',
    '결제는 매장에서 직접 진행되며, 다양한 결제 수단을 이용하실 수 있어요',
    '주차 가능 여부는 매장별로 다르니 예약 시 확인해주세요'
  ];

  return (
    <section>
      <div className="bg-white rounded-3xl p-8 shadow-lg">
        <div className="mb-8">
          <h2 className="text-2xl font-medium text-gray-800 mb-2">예약 진행 안내</h2>
          <p className="text-sm text-gray-600">예약 전 꼭 확인해주세요</p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-2xl bg-gradient-to-br from-rose-400 to-pink-400">
                <i className={`${step.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-base font-medium text-gray-800 mb-2">{step.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>

        {/* Notices */}
        <div className="bg-gradient-to-br from-rose-50 to-pink-50 rounded-2xl p-6">
          <h3 className="text-lg font-medium text-gray-800 mb-4 flex items-center">
            <i className="ri-information-line text-rose-400 mr-2"></i>
            주의사항
          </h3>
          <ul className="space-y-3">
            {notices.map((notice, index) => (
              <li key={index} className="flex items-start">
                <i className="ri-checkbox-circle-fill text-rose-400 mt-0.5 mr-3 flex-shrink-0"></i>
                <span className="text-sm text-gray-700 leading-relaxed">{notice}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600 mb-3">예약 관련 문의사항이 있으신가요?</p>
          <button className="px-6 py-3 border-2 border-rose-400 text-rose-400 text-sm font-medium rounded-full hover:bg-rose-400 hover:text-white transition-all whitespace-nowrap cursor-pointer">
            <i className="ri-customer-service-2-line mr-2"></i>
            고객센터 문의하기
          </button>
        </div>
      </div>
    </section>
  );
}
